import React, { useEffect, useState } from "react";
import {
  Table,
  Button,
  Modal,
  Form,
  Input,
  message,
  Popconfirm,
} from "antd";
import axios from "axios";
import API_BASE from "../config/api";

const AdminPage = () => {
  const [adminList, setAdminList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [adminModalVisible, setAdminModalVisible] = useState(false);

  const [adminForm] = Form.useForm();

  // 🔐 Protected admin (no delete button)
  const protectedEmail = "nikhilvar85@gmail.com";

  // ================= FETCH ADMINS =================
  const fetchAdmins = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${API_BASE}/getAdmin`);
      setAdminList(data?.data || []);
    } catch (err) {
      console.error(err);
      message.error("Failed to fetch admins");
    } finally {
      setLoading(false);
    }
  };

  // ================= ADD ADMIN =================
  const handleAddAdmin = async (values) => {
    try {
      const payload = {
        email: values.email,
      };

      const { data } = await axios.post(`${API_BASE}/addAdmin`, payload);

      if (data?.success) {
        message.success("Admin added successfully");
        setAdminModalVisible(false);
        adminForm.resetFields();
        fetchAdmins();
      } else {
        message.error(data.message || "Failed to add admin");
      }
    } catch (err) {
      console.error(err);
      message.error("Failed to add admin");
    }
  };

  // ================= DELETE ADMIN =================
  const handleDeleteAdmin = async (id) => {
    try {
      await axios.delete(`${API_BASE}/deleteAdmin/${id}`);
      message.success("Admin deleted");
      fetchAdmins();
    } catch (err) {
      console.error(err);
      message.error("Delete failed");
    }
  };

  // ================= EFFECT =================
  useEffect(() => {
    fetchAdmins();
  }, []);

  return (
    <div className="modSpace">
      <h2>Admin Manager</h2>

      {/* ===== ADD ADMIN BUTTON ===== */}
      <Button
        type="primary"
        onClick={() => {
          adminForm.resetFields();
          setAdminModalVisible(true);
        }}
      >
        Add Admin
      </Button>

      {/* ===== ADMIN TABLE ===== */}
      <Table
        style={{ marginTop: 20 }}
        loading={loading}
        rowKey="id"
        dataSource={adminList}
        columns={[
          {
            title: "Email",
            dataIndex: "email",
          },
          {
            title: "Actions",
            render: (_, record) => {
              // ❌ Hide delete for protected admin
              if (record.email === protectedEmail) {
                return null;
              }

              return (
                <Popconfirm
                  title="Delete this admin?"
                  onConfirm={() => handleDeleteAdmin(record.id)}
                >
                  <Button type="link" danger>
                    Delete
                  </Button>
                </Popconfirm>
              );
            },
          },
        ]}
      />

      {/* ===== ADD ADMIN MODAL ===== */}
      <Modal
        title="Add Admin"
        open={adminModalVisible}
        onCancel={() => {
          setAdminModalVisible(false);
          adminForm.resetFields();
        }}
        onOk={() => adminForm.submit()}
        destroyOnClose
      >
        <Form
          form={adminForm}
          layout="vertical"
          onFinish={handleAddAdmin}
        >
          <Form.Item
            label="Email"
            name="email"
            rules={[
              { required: true, message: "Email is required" },
              { type: "email", message: "Enter a valid email" },
            ]}
          >
            <Input placeholder="Enter admin email" />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default AdminPage;
